import React from 'react'
import { Container, BoxCol6, ImagemPrincipal, TextoBanner, BoxEconomize, BoxEconomizeTexto, BoxAssinaturas, ItemAssinatura, ItemAssinaturaTag, ItemAssinaturaTitulo, ItemAssinaturaPrecoDe, ItemAssinaturaPrecoPor, ItemAssinaturaLinkCartao, ItemAssinaturaLinkAVista } from './Styled'
import logoBlackFriday2025 from 'images/black-friday-2025/black-friday-2025.png'
import bgBannerDesktop from 'images/black-friday-2025/bg-banner-principal-desktop.jpg'
import bgBannerMobile from 'images/black-friday-2025/bg-banner-principal-mobile.jpg'

export default function BannerPrincipal ({ nome, planos, desconto }) {

	return (
		<Container bgDesktop={bgBannerDesktop} bgMobile={bgBannerMobile}>

			{/* Textos Banner */}
			<BoxCol6 className='boxTextos'>
				<ImagemPrincipal src={logoBlackFriday2025} />
				<TextoBanner>OS <strong>MAIORES DESCONTOS</strong> E OS<br /> <strong>MELHORES BÔNUS</strong> estão aqui<br /> na sua área do aluno!</TextoBanner>
			</BoxCol6>

			{/* Aviso Banner */}
			<BoxCol6>
				
				{/* Box Economize */}
				<BoxEconomize>
					<BoxEconomizeTexto>{nome.split(" ")[0]}, DESBLOQUEIE AGORA ATÉ {desconto}% OFF</BoxEconomizeTexto>
				</BoxEconomize>

				{/* Lista Assinaturas */}
				<BoxAssinaturas>

					{ planos.map((assinatura, indexAssinaturas) => {
						return assinatura.assinaturas.map((item, index) => {

							return index > 0 ?

								<ItemAssinatura key={index}>

									{/* Tag */}
									<ItemAssinaturaTag primeiro={ indexAssinaturas == 0 ? true : false }>{ indexAssinaturas === 0 ? 'A mais vendida' : 'Custo x Benefício' }</ItemAssinaturaTag>

									{/* Título */}
									<ItemAssinaturaTitulo>{item.nome.split(" - ")[0]}</ItemAssinaturaTitulo>

									{/* Preço De */}
									<ItemAssinaturaPrecoDe>{item.cartao.preco_de} por</ItemAssinaturaPrecoDe>

									{/* Preço Por */}
									<ItemAssinaturaPrecoPor>12x <strong>{item.cartao.preco_por.split('12x ')[1]}</strong></ItemAssinaturaPrecoPor>

									{/* Link Cartão */}
									<ItemAssinaturaLinkCartao href={item.cartao.link}>Parcele em 12x sem juros</ItemAssinaturaLinkCartao>

									{/* Link A Vista */}
									<ItemAssinaturaLinkAVista href={item.boleto.link}>Ganhe +10% OFF à vista</ItemAssinaturaLinkAVista>

								</ItemAssinatura> : null

						})
					})}

				</BoxAssinaturas>

			</BoxCol6>

		</Container>
	)
	}
